export default __webpack_public_path__ + "static/082-a3e53169e6d7b266d85bd768b4832b5b.jpg";